import {Type} from '@mintdata/mint-kit/api/types/Type';
import {AEmpty} from '@mintdata/mint-kit/api/values/AEmpty';
import {AError} from '@mintdata/mint-kit/api/values/AError';

export type Empty = null;
export const Empty = null;

export type ErrorOrEmpty = AError | AEmpty;

export interface IValueInfo
{
    value?:any;
    error?:string;
}

export interface IValue
{
    error?:string;
    isError:boolean;
    isEmpty:boolean;
    isFrame:boolean;

    getType():Type;

    toString():string;
    toValue():string;

    isEqualTo(other:IValue):boolean;
    compareTo(other:IValue):number;
    clone():IValue;
}

export type IValueConstructor = {new(...args):IValue};
